module.exports = __webpack_public_path__ + "img/em-logo-1.04ba71ff.svg";